import styled from "styled-components"
import { BlueBtn, Box, BtnBox, Heading } from "./contentOwnernship"


const FlexBox = styled.div`
@media (min-width: 768px)
{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
}


    flex-wrap: wrap;

    padding-left: .5rem;
    padding-right: .5rem;
    justify-content: center;
    
    flex-direction: row;
    display: flex;
    margin-bottom: 2.5rem;
`

const RoundCard = styled.div`
@media (min-width: 1024px)
{
    border: 1px solid rgba(0,0,0,.1);
}
@media (min-width: 1024px)
 {
    width: 25%;
}
@media (min-width: 1024px)
{
    margin-bottom: 0;
}
@media (min-width: 768px)
{
    padding: 2rem;
}
@media (min-width: 768px)
{
    --tw-bg-opacity: 1;
        background-color: rgba(255,255,255,var(--tw-bg-opacity));
}
    text-align: center;
    padding-top: .5rem;
    padding-bottom: .5rem;
    background-color: transparent;
    border-radius: .5rem;
    align-items: center;
    flex-direction: column;
    width: 50%;
    display: flex;
    margin-bottom: 1.25rem;
`

const ImgBox = styled.div`
@media (min-width: 768px)
{
    height: 4rem;
}

    opacity: .5;

    --tw-text-opacity: 1;
    color: rgba(66,66,66,var(--tw-text-opacity));
 
    height: 3rem;

   margin-bottom: 1.25rem;

`
const NorCard = styled.div`

@media (min-width: 1024px)
 {
    width: 25%;
}
@media (min-width: 1024px)
{
    margin-bottom: 0;
}
@media (min-width: 768px)
{
    padding: 2rem;
}
@media (min-width: 768px)
{
    --tw-bg-opacity: 1;
        background-color: rgba(255,255,255,var(--tw-bg-opacity));
}
    text-align: center;
    padding-top: .5rem;
    padding-bottom: .5rem;
    background-color: transparent;
    align-items: center;
    flex-direction: column;
    width: 50%;
    display: flex;
    margin-bottom: 1.25rem;
`

const ImgSvg = styled.svg`
    
    vertical-align: middle;
    height: 100%;
    width: auto;
    fill: currentColor;
    stroke: currentColor;
`
const Title = styled.h2`
    margin: 0;
    margin-bottom: .5rem;
    font-weight: 600;
    letter-spacing: -0.025em;
    --tw-text-opacity: 1;
        color: rgba(66,66,66,var(--tw-text-opacity));
    
        @media (min-width: 768px)
    {
        font-size: 1.5rem;
        line-height: 2rem;
    }
`
const Info = styled.p`
@media (min-width: 768px)
 {
    display: block;
}

    --tw-text-opacity: 1;
    color: rgba(97,97,97,var(--tw-text-opacity));


    line-height: 1.375;



    font-size: 1rem;
    line-height: 1.5rem;


    display: none;

    margin:0;

`
export const Features = () => {

    return(
        <Box>
        <Heading>
            Features that will make your blogging 10x better
        </Heading>
        <FlexBox>
            <RoundCard>
              <ImgBox>
              <ImgSvg viewBox="0 0 496 512"><path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path></ImgSvg>
              </ImgBox>
              <Title>
              Automatic GitHub Backup
              </Title>
              <Info>
              Every time you publish an article on your blog, a markdown version of the post is pushed to your private GitHub repo as a backup.
              </Info>
            </RoundCard>
            <NorCard>
                <ImgBox>
                <ImgSvg viewBox="0 0 512 512"><path d="M444.396 114.479H67.603c-18.328 0-33.206 14.879-33.206 33.135v216.703c0 18.327 14.878 33.205 33.206 33.205h376.865c18.326 0 33.206-14.878 33.135-33.133V147.613c0-18.256-14.879-33.134-33.207-33.134zM266.898 331.182h-44.203v-86.25l-44.203 55.272-44.202-55.272v86.25H89.943V180.819h44.204l44.203 55.272 44.203-55.272h44.202v150.362h.143zm97.247 2.228l-66.34-77.409h44.203v-75.182h44.203v75.182h44.203l-66.269 77.409z" fill="none" stroke="stroke-current" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"></path></ImgSvg>
                </ImgBox>
                <Title>
                Write in Markdown
                </Title>
                <Info>
                Write your content in a distraction-free Markdown editor with proper syntax highlighting and see live previews instantly. Embed images, code snippets, tweets, and much more.
                </Info>
            </NorCard>
            <RoundCard>
              <ImgBox>
              <ImgSvg viewBox="0 0 24 24"><path d="M12 0a12 12 0 1012 12A12 12 0 0012 0zm0 22a10 10 0 1110-10 10 10 0 01-10 10z"></path><path d="M13 4l-4 9 3 .07L11 20l4-9-3-.07L13 4z"></path></ImgSvg>
              </ImgBox>
              <Title>
              Superfast Next.js Powered Blogs
              </Title>
              <Info>
              EveryHashnode blogs are powered by Next.js, and are served via Vercel's word class CDN.
              </Info>
            </RoundCard>
            <NorCard>
                <ImgBox>
                <ImgSvg viewBox="0 0 24 24"><path d="M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41c2.93 1.18 5 4.05 5 7.41 0 2.08-.8 3.97-2.1 5.39M11 19.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.22.21-1.79L9 15v1a2 2 0 0 0 2 2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2z"></path></ImgSvg>
                </ImgBox>
                <Title>
                Blog on a Custom Domain
                </Title>
                <Info>
                Bring your custom domain, and get up and running within minutes. We issue, and renew SSL cert for you automatically.
                </Info>
            </NorCard>
            <RoundCard>
              <ImgBox>
              <ImgSvg viewBox="0 0 512 512"><path d="M464 128H272l-54.63-54.63A32 32 0 00194.74 64H48a48 48 0 00-48 48v288a48 48 0 0048 48h416a48 48 0 0048-48V176a48 48 0 00-48-48zM314.85 288L256 350l-58.84-62zM480 400a16 16 0 01-16 16H48a16 16 0 01-16-16V112a16 16 0 0116-16h146.74L240 141.27V256h-52.65a26.94 26.94 0 00-25 16.72 28.38 28.38 0 005.44 30.81l68.12 71.78c10.69 11.19 29.51 11.2 40.19 0l68.12-71.75a28.43 28.43 0 005.44-30.83 26.94 26.94 0 00-25-16.72H272V160h192a16 16 0 0116 16z"></path></ImgSvg>
              </ImgBox>
              <Title>
              Own your data
              </Title>
              <Info>
              You retain all the rights to your content. Export and download all your posts from your dashboard with a single click.
              </Info>
            </RoundCard>
            <NorCard>
                <ImgBox>
                <ImgSvg viewBox="0 0 512 512"><path d="M466.5 83.7l-192-80a48.15 48.15 0 00-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM262.2 478.8c-4 1.6-8.4 1.6-12.3 0C152 440 48 304 48 128c0-6.5 3.9-12.3 9.8-14.8l192-80c3.9-1.6 8.4-1.6 12.3 0l192 80c6 2.5 9.9 8.3 9.8 14.8.1 176-103.9 312-201.7 350.8zm136.2-325c-4.7-4.7-12.3-4.7-17-.1L218 315.8l-69-69.5c-4.7-4.7-12.3-4.7-17-.1l-8.5 8.5c-4.7 4.7-4.7 12.3-.1 17l85.9 86.6c4.7 4.7 12.3 4.7 17 .1l180.5-179c4.7-4.7 4.7-12.3.1-17z"></path></ImgSvg>
                </ImgBox>
                <Title>
                Edge Caching with SSL
                </Title>
                <Info>
                We automatically cache your blog using Vercel, and serve it over HTTPS. This results in low time to first byte (TTFB) and allows your blog to be extremely responsive and fast.
                </Info>
            </NorCard>
            <RoundCard>
              <ImgBox>
              <ImgSvg viewBox="0 0 24.013 24.027"><g><g fill="none" stroke="stroke-current" stroke-linecap="round" stroke-linejoin="round"><rect height="23" rx="1" ry="1" width="23" x=".513" y=".526"></rect><path d="M2.512 2.526h0M4.512 2.526h0M6.512 2.526h0M.513 4.526h23M9.5 23.527V12.5l-2-4-2 4v11.027M18.5 23.527V9.5h-5v14.027M5.5 12.5h4M18.5 11.5h-3M18.5 13.5h-2M18.5 15.5h-3M18.5 17.5h-2M18.5 19.5h-3M18.5 21.5h-2"></path></g><path fill="none" d="M0 0h24v24H0z"></path></g></ImgSvg>
              </ImgBox>
              <Title>
              Customise Design using CSS
              </Title>
              <Info>
              Modify the appearance of your blog using our Custom CSS feature. Change the font family, font size, primary link colors, and more. 
              </Info>
            </RoundCard>
            <NorCard>
                <ImgBox>
                <ImgSvg viewBox="0 0 200 200"><g fill="fill-current"><path d="M175.53 69.774l-68.8-34.133c-3.26-1.617-8.534-1.623-11.797-.012L25.741 69.78c-3.598 1.775-6.311 6.14-6.311 10.153v77.2c0 4.632 3.768 8.4 8.4 8.4h145.6c4.632 0 8.4-3.768 8.4-8.4v-77.2c0-4.01-2.709-8.376-6.3-10.159zm-96.947 48.762L26.63 155.007V80.336l51.953 38.2zm65.134-24.044l-39.82 29.764c-1.371 1.024-3.973 1.036-5.351.021l-41.004-30.15V70.933h86.174v23.559zm-59.013 28.545l9.577 7.042c1.945 1.43 4.432 2.144 6.921 2.144 2.523 0 5.047-.734 7.006-2.199l8.863-6.625 49.764 34.934H34.424l50.28-35.296zm38.436-4.175l51.49-38.488v74.633l-51.49-36.145zM98.119 42.085c.637-.314 1.645-.502 2.698-.502 1.058 0 2.073.189 2.713.507l66.292 32.889-18.905 14.131V69.732c0-3.308-2.692-6-6-6H56.342c-3.308 0-6 2.692-6 6v19.102L31.488 74.972l66.631-32.887z"></path><path d="M71.852 78.289h57.556v7.2H71.852zM71.852 92.845h57.556v7.2H71.852z"></path></g></ImgSvg>
                </ImgBox>
                <Title>
                Free built-in newsletter service
                </Title>
                <Info>
                Enable a newsletter service with the click of a button, and let your readers easily subscribe to your blog.
                </Info>
            </NorCard>
            <RoundCard>
              <ImgBox>
              <ImgSvg viewBox="0 0 640 512"><path d="M608 0H192c-17.67 0-32 14.33-32 32v96c-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-41.74-26.8-76.9-64-90.12V32h416v352H305.34c-.59-.94-1.03-1.96-1.65-2.88-17.25-25.62-46.67-39.11-76.9-39.11C199 342.02 192.02 352 160 352c-31.97 0-38.95-9.98-66.79-9.98-30.23 0-59.65 13.48-76.9 39.11C6.01 396.42 0 414.84 0 434.67V472c0 22.09 17.91 40 40 40h240c22.09 0 40-17.91 40-40v-37.33c0-6.41-.84-12.6-2.04-18.67H608c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM224 224c0 35.29-28.71 64-64 64s-64-28.71-64-64 28.71-64 64-64 64 28.71 64 64zm64 248c0 4.41-3.59 8-8 8H40c-4.41 0-8-3.59-8-8v-37.33c0-12.79 3.75-25.13 10.85-35.67 10.53-15.64 29.35-24.98 50.36-24.98 21.8 0 29.99 9.98 66.79 9.98 36.79 0 45.01-9.98 66.79-9.98 21 0 39.83 9.34 50.36 24.98 7.1 10.54 10.85 22.88 10.85 35.67V472zm50.62-319.31c-9.38-9.38-24.56-9.38-33.94 0l-25.49 25.49c4.56 11.72 7.3 24.17 8.21 37.04l34.25-34.25L384.69 244c4.69 4.69 10.81 7.02 16.97 7.02s12.28-2.33 16.97-7.02l58.97-58.97 33.24 33.24c3.96 3.96 8.82 5.73 13.6 5.73 9.99 0 19.57-7.76 19.57-19.47v-95.58c0-7.15-5.8-12.95-12.95-12.95h-95.58c-17.31 0-25.98 20.93-13.74 33.17l33.24 33.24-53.31 53.31-63.05-63.03zM512 128v46.18L465.82 128H512z"></path></ImgSvg>
              </ImgBox>
              <Title>
              Built-in Analytics
              </Title>
              <Info>
              Powerful analytics to track the number of views, likes, and comments, and analyze the performance of your articles over a period of time. 
              </Info>
            </RoundCard>
            <NorCard>
                <ImgBox>
                <ImgSvg viewBox="0 0 512 512"><path d="M512 256.01c0-9.98-5.81-18.94-14.77-22.81l-99.74-43.27 99.7-43.26c9-3.89 14.81-12.84 14.81-22.81s-5.81-18.92-14.77-22.79L271.94 3.33c-10.1-4.44-21.71-4.45-31.87-.02L14.81 101.06C5.81 104.95 0 113.9 0 123.87s5.81 18.92 14.77 22.79l99.73 43.28-99.7 43.26C5.81 237.08 0 246.03 0 256.01c0 9.97 5.81 18.92 14.77 22.79l99.72 43.26-99.69 43.25C5.81 369.21 0 378.16 0 388.14c0 9.97 5.81 18.92 14.77 22.79l225.32 97.76a40.066 40.066 0 0015.9 3.31c5.42 0 10.84-1.1 15.9-3.31l225.29-97.74c9-3.89 14.81-12.84 14.81-22.81 0-9.98-5.81-18.94-14.77-22.81l-99.72-43.26 99.69-43.25c9-3.89 14.81-12.84 14.81-22.81zM45.23 123.87l208.03-90.26.03-.02c1.74-.71 3.65-.76 5.45.02l208.03 90.26-208.03 90.27c-1.81.77-3.74.77-5.48 0L45.23 123.87zm421.54 264.27L258.74 478.4c-1.81.77-3.74.77-5.48 0L45.23 388.13l110.76-48.06 84.11 36.49a40.066 40.066 0 0015.9 3.31c5.42 0 10.84-1.1 15.9-3.31l84.11-36.49 110.76 48.07zm-208.03-41.87c-1.81.77-3.74.77-5.48 0L45.23 256 156 207.94l84.1 36.5a40.066 40.066 0 0015.9 3.31c5.42 0 10.84-1.1 15.9-3.31l84.1-36.49 110.77 48.07-208.03 90.25z"></path></ImgSvg>
                </ImgBox>
                <Title>
                Article Series
                </Title>
                <Info>
                Series is a great way to organize your content. It helps you easily group a series of articles related to a single topic.
                </Info>
            </NorCard>
            <RoundCard>
              <ImgBox>
              <ImgSvg viewBox="0 0 384 512"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-48-244v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12z"></path></ImgSvg>
              </ImgBox>
              <Title>
              Drafts
              </Title>
              <Info>
              Share your drafts with your friends to get some early feedback before you hit the publish button. 
              </Info>
            </RoundCard>
            <NorCard>
                <ImgBox>
                <ImgSvg  viewBox="0 0 512 512"><path d="M504 88v112a16 16 0 01-32 0V88a16.018 16.018 0 00-16-16H56a16.018 16.018 0 00-16 16v48h400a16 16 0 010 32H40v32a16 16 0 01-32 0V88a48.055 48.055 0 0148-48h400a48.055 48.055 0 0148 48zm-16 290a16 16 0 00-16 16v30a16.018 16.018 0 01-16 16H56a16.018 16.018 0 01-16-16v-30a16 16 0 00-32 0v30a48.055 48.055 0 0048 48h400a48.055 48.055 0 0048-48v-30a16 16 0 00-16-16zM45 236.155a16 16 0 00-16 16v89.69a16 16 0 0032 0V313h14v28.845a16 16 0 0032 0v-89.69a16 16 0 10-32 0V281H61v-28.845a16 16 0 00-16-16zM162 358a16 16 0 0016-16v-74h8a16 16 0 000-32h-48a16 16 0 000 32h8v74a16 16 0 0016 16zm164.311-.155a16 16 0 01-16-16v-89.69a16 16 0 0116-16h18.2a44.727 44.727 0 0144.676 44.677c0 25.158-18.852 45.358-46.878 45.358v15.655a16 16 0 01-15.998 16zm18.2-89.69h-2.2v26.035h2.2c6.482 0 12.676-4.948 12.676-13.358a12.691 12.691 0 00-12.674-12.677zm100.189 57.69H421a16 16 0 000 32h23.7A38.338 38.338 0 00483 319.3c0-19.727-15.3-38.3-39.7-38.3a6.424 6.424 0 010-12.845H467a16 16 0 100-32h-23.7A38.338 38.338 0 00405 274.7c0 19.727 15.3 38.3 39.7 38.3a6.424 6.424 0 010 12.845zM256 358a16 16 0 0016-16v-74h8a16 16 0 000-32h-48a16 16 0 000 32h8v74a16 16 0 0016 16zM68.87 88.31a16 16 0 004.7 31.61c22.038-2.12 17.176-35.811-4.7-31.61zm45.01.92c-13.012 5.42-13.239 24.018 0 29.54a15.967 15.967 0 0019.42-5.89c8.852-13.122-4.982-29.665-19.42-23.65zm40.82 5.89a16.019 16.019 0 004.42 22.18c11.561 7.8 27.311-2.192 24.57-16.43a16.007 16.007 0 00-28.99-5.75z"></path></ImgSvg>
                </ImgBox>
                <Title>
                HTTPS by default
                </Title>
                <Info>
                It doesn't matter if you are using our free subdomain or a custom one. We provide SSL certificates for free for all the blogs.
                </Info>
            </NorCard>
        </FlexBox>
        <BtnBox>
          <BlueBtn target="_blank" href="#">
              Get Started
          </BlueBtn>
          </BtnBox>
        </Box>
       
    )
}